import { EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../../common.service";
import { ApiService } from "../../api.service";
import { CookieService } from "ngx-cookie-service";
var LearningCampReportComponent = (function () {
    function LearningCampReportComponent(route, router, apiService, cookieService, commonService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
        this.cookieService = cookieService;
        this.commonService = commonService;
        this.onCloseLearningCampReport = new EventEmitter();
        this.isClosePage = false; //是否关闭页面
        this.assetsRoute = "../../../assets"; //静态资源地址
        this.isShowCommonBtn = false;
    }
    LearningCampReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userName = localStorage.getItem('userName');
        this.commonService.getOnceIno(this.onceValue).then(function (result) {
            _this.isShowCommonBtn = result === 1 ? false : true;
        });
    };
    LearningCampReportComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.savePic();
        }, 500);
    };
    //H5转png
    LearningCampReportComponent.prototype.savePic = function () {
        var _this = this;
        var dom = document.getElementById('user-certificate');
        // let width = dom.scrollWidth;
        // let height = dom.scrollHeight;
        var width = dom.offsetWidth;
        var height = dom.offsetHeight;
        var scale = this.setDPR();
        var y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        var cs = document.createElement('canvas');
        cs.width = width * scale;
        cs.height = height * scale;
        cs.style.width = cs.width / 50 + 'rem';
        cs.style.height = cs.height / 50 + 'rem';
        var ctx = cs.getContext('2d');
        ctx.scale(scale, scale);
        $(dom).scrollTop(0, y);
        html2canvas(dom, {
            dpi: 300,
            backgroundColor: '#FFFFFE',
            canvas: cs,
            scale: scale / scale,
            useCORS: true,
            allowTaint: true,
            taintTest: false,
            width: width,
            height: height
        }).then(function (canvas) {
            var context = canvas.getContext('2d');
            context.mozImageSmoothingEnabled = false;
            context.webkitImageSmoothingEnabled = false;
            context.msImageSmoothingEnabled = false;
            context.imageSmoothingEnabled = false;
            $('#user-certificate-img').attr('src', canvas.toDataURL("image/png", 1.0));
        }).then(function () {
            $('#user-certificate').hide();
            _this.commonService.initPage({
                'backgroundColor': '#F2F3FA'
            });
        });
    };
    //根据window.devicePixelRatio获取像素比
    LearningCampReportComponent.prototype.setDPR = function () {
        return window.devicePixelRatio && window.devicePixelRatio > 1 ? window.devicePixelRatio : 1;
    };
    //毕业生称号注解
    LearningCampReportComponent.prototype.reportAchievementExplain = function (level) {
        return { 1: '结业证书', 2: '毕业证书', 3: '优秀毕业证书' }[level] || "荣誉毕业生";
    };
    //报告等级注解
    LearningCampReportComponent.prototype.reportLevelExplain = function (level) {
        return { 1: '薄弱', 2: '有限', 3: '一般', 4: '良好', 5: '优秀', 6: '卓越' }[level] || '良好';
    };
    //关闭学习旅程
    LearningCampReportComponent.prototype.closeLearningCampReport = function () {
        var _this = this;
        this.isClosePage = true;
        this.commonService.setOnceIno(this.onceValue).subscribe(function () {
            setTimeout(function () {
                _this.onCloseLearningCampReport.emit();
            }, 300);
        });
    };
    return LearningCampReportComponent;
}());
export { LearningCampReportComponent };



// WEBPACK FOOTER //
// ./src/app/learning-camp/camp-report/learning-camp-report.component.ts.pre-build-optimizer.js